<div class="relative w-full overflow-hidden aarni-font hidden md:block mt-[80px]">
    <img src="assets/img/research-banner.jpg" alt="Desktop Image" class="w-full h-auto object-contain">
    <div class="absolute top-[40%] left-[12%] m-4 text-white px-4 py-2 rounded text-6xl font-bold">
        <p>RESEARCH</p>
        <p>DEVELOPMENT CELL</p>
    </div>
</div>

<div class="relative w-full overflow-hidden aarni-font md:hidden mt-[80px]">
    <img src="assets/img/research-mobile-banner.jpg" alt="Mobile Image" class="w-full h-auto object-contain">
    <div class="absolute inset-0 flex items-center justify-center text-white text-center px-4">
        <div class="text-3xl font-bold">
            <p>RESEARCH</p>
            <p>DEVELOPMENT CELL</p>
        </div>
    </div>
</div>

<section class="aarni-font text-justify">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-fit lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Research</h2>
                    <div class="">
                        <a [href]="'/research/research-overview'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Research Overview', 'text-blue-600 bg-white' : pageTitle !== 'Research Overview'}"
                           class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Research Overview</span>
                        </a>
                        <a [href]="'/research/phd-programme'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Ph.D. Programme', 'text-blue-600 bg-white' : pageTitle !== 'Ph.D. Programme'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Ph.D. Program</span>
                        </a>
                        <a [href]="'/research/ipr-policy'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === '', 'text-blue-600 bg-white' : pageTitle !== ''}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Research Policy</span>
                        </a>
                        <a [href]="'/research/research-paper-publication'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === '', 'text-blue-600 bg-white' : pageTitle !== ''}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Research Publication</span>
                        </a>
                        <a [href]="'/research/research-projects'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Research Projects', 'text-blue-600 bg-white' : pageTitle !== 'Research Projects'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Research Projects</span>
                        </a>
                        <a [href]="'/research/patents-and-copyright'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Patents & Copyright', 'text-blue-600 bg-white' : pageTitle !== 'Patents & Copyright'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Patents & Copyright</span>
                        </a>
                        <a [href]="'/research/phd-regulations'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Ph.D. Regulations', 'text-blue-600 bg-white' : pageTitle !== 'Ph.D. Regulations'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Ph.D. Regulations</span>
                        </a>
                        <a [href]="'/research/collaborations-or-mou'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Collaborations/MOUs', 'text-blue-600 bg-white' : pageTitle !== 'Collaborations/MOUs'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Collaborations/MOUs</span>
                        </a>
                        <a [href]="'/research/conference-or-workshop'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Conference/Workshop', 'text-blue-600 bg-white' : pageTitle !== 'Conference/Workshop'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Conference/Workshop</span>
                        </a>
                        <a [href]="'/research/downloads'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Downloads', 'text-blue-600 bg-white' : pageTitle !== 'Downloads'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Downloads</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Faculty</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Leadership</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1 aarni-font">
            <div class="p-4 md:p-8 h-fit shadow-md bg-white">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div id="overview" *ngIf="pageTitle === 'Research Overview'">
                    <p class="mt-8 text-gray-500">
                        ARNI University, offers a dynamic and rigorous platform for Doctoral research across diverse
                        disciplines. Established with a vision to foster academic excellence and innovation, the
                        university’s Ph.D. programs are designed to cultivate independent research skills, critical
                        thinking, and scholarly contribution.
                    </p>

                    <p class="mt-4 text-gray-500">
                        The Ph.D. programs at ARNI University span a wide array of fields including Management,
                        Engineering & Technology, Pharmaceutical Sciences, Agriculture, Basic Sciences & Boi-Technology,
                        Humanities and Social Sciences. Each program is rooted in the university’s commitment to
                        interdisciplinary learning and real-world application, encouraging scholars to engage with
                        contemporary challenges and advance knowledge within their chosen field.
                    </p>

                    <p class="mt-4 text-gray-500">
                        The research process at ARNI is structured yet flexible, comprising coursework, comprehensive
                        examinations, and original research leading to a dissertation. The university emphasizes ethical
                        research practices, and its scholars benefit from mentorship by experienced faculty, access to
                        well-equipped laboratories, and collaborations with industry and academic institutions.
                    </p>
                    <p class="mt-4 text-gray-500">ARNI University fosters a research culture that is inclusive and
                        progressive, welcoming scholars from diverse backgrounds. Regular workshops, seminars, and
                        conferences are organized to enhance academic engagement and keep scholars updated with the
                        latest advancements. The university also offers fellowships and financial assistance to
                        deserving candidates, supporting their academic journey.</p>
                    <div class="mt-8">
                        <h3 class="text-lg font-semibold mb-2">VISION AND MISSION FOR RESEARCH EXCELLENCE</h3>
                        <p class="mt-4 text-gray-500">Arni University envisions becoming a hub for high-impact research
                            that not only contributes
                            to academic scholarship but also offers practical solutions to societal issues. The
                            university's mission is to nurture a research environment that encourages creativity,
                            critical thinking, and a passion for discovery among faculty and students alike. Guided by
                            the principles of innovation, inclusivity, and sustainability, Arni aims to produce research
                            outcomes that align with national priorities and global development goals.</p>
                    </div>
                    <div class="mt-8">
                        <h3 class="text-lg font-semibold mb-2">STRATEGIC RESEARCH FOCUS AREAS</h3>
                        <p class="mt-4 text-gray-500">The university supports a wide array of research domains that span
                            across disciplines such as Management, Engineering & Technology, Pharmaceutical Sciences,
                            Agriculture, Basic Sciences & Bio-Technology, Humanities and Social Sciences. These research
                            areas are strategically chosen to reflect both local and global needs, thereby ensuring that
                            the work produced has a meaningful impact.</p>
                    </div>
                    <div class="mt-8">
                        <ol class="list-decimal list-inside space-y-2 text-gray-500">
                            <li><span class="font-semibold">SCIENCE AND TECHNOLOGY:</span> Research in areas
                                such as artificial intelligence, machine learning, renewable energy, Science &
                                biotechnology and nanotechnology is at the forefront of Arni University Scientific
                                endeavors. The Engineering and Computer Science Departments are especially active in
                                developing solutions for automation, data analytics, and energy efficiency.
                            </li>
                            <li><span class="font-semibold">AGRICULTURE:</span> Given the rural setting of the
                                university, a significant portion of its research is devoted to sustainable agricultural
                                practices, organic farming, soil and water conservation, and the use of technology in
                                rural development. The aim is to improve livelihoods and food security in the region
                                through scientific innovation.
                            </li>
                            <li><span class="font-semibold">HEALTHCARE AND LIFE SCIENCES:</span> Arni University
                                promotes research in Chemistry, Biochemistry, Microbiology, Botany and Public Health,
                                with a focus on indigenous healthcare systems and preventive medicine. Collaborative
                                projects with local healthcare providers help in addressing region-specific health
                                challenges.
                            </li>
                            <li><span class="font-semibold">SOCIAL SCIENCES AND HUMANITIES:</span> The
                                university places strong emphasis on social research, including studies in Education,
                                Rural sociology, Gender equity, Economics, Psychology, Cultural Preservation and many
                                more. These efforts aim to understand and address the socio-cultural dynamics affecting
                                communities in Himachal Pradesh and beyond.
                            </li>
                        </ol>
                    </div>
                    <div class="mt-8">
                        <h3 class="text-lg font-semibold mb-2">INFRASTRUCTURE AND RESEARCH FACILITIES</h3>
                        <p class="mt-4 text-gray-500">Arni University provided the facility of modern laboratories,
                            research centers, and computing facilities that support a diverse range of experimental and
                            theoretical research. The Central Research Laboratory, equipped with state-of-the-art
                            instruments, serves as a shared resource for scholars from various disciplines. The
                            university also maintains a digital library and access to numerous online journals and
                            databases, facilitating a research ecosystem that is globally connected and
                            resource-rich.</p>
                    </div>
                    <div class="mt-8">
                        <h3 class="text-lg font-semibold mb-2">FACULTY AND STUDENTS ARE DEEPLY ENGAGED IN RESEARCH,
                            REFLECTING THE UNIVERSITY’S</h3>
                        <ul class="list-disc pl-5 text-gray-500">
                            <li>Strong dedication to promoting and sustaining research excellence.</li>
                            <li>Strategic emphasis on high-potential emerging fields, including Nanotechnology,
                                Bioengineering, Energy, Environment, Materials Science, and Embedded Systems.
                            </li>
                            <li>Dedicated participation in conferences, workshops, and impactful research projects that
                                contribute to nation-building and social welfare, particularly in areas like rural
                                healthcare and other community-driven initiatives.
                            </li>
                        </ul>
                    </div>
                </div>

                <div *ngIf="pageTitle === 'Ph.D. Programme'">
                    <p class="mt-8 text-gray-500">
                        At ARNI University, we are deeply committed to advancing research and innovation through our
                        well-structured Ph.D. programs. Our mission is to develop a culture of academic excellence by
                        encouraging scholars to pursue high-level research that significantly contributes to their
                        chosen fields. Well designed to develop thought leaders, innovators, and academic professionals,
                        our Ph.D. programs providing an intellectually stimulating environment supported by modern
                        infrastructure, experienced faculty, and strong industry linkages.
                    </p>
                    <p class="mt-2 text-gray-500">Our Research-driven approach is complemented by a collaborative
                        academic ecosystem that supports
                        interdisciplinary Studies and promotes the integration of theoretical knowledge with practical
                        Application. We strive to cultivate researchers, who are not only academically sound but also
                        capable of addressing real-world challenges through innovative thinking and problem-solving
                        abilities. ARNI University places a strong emphasis on building Academic and Industry
                        partnerships to ensure that research outcomes are relevant and impactful.</p>
                    <div>
                        <h3 class="mt-6 text-[16px] font-semibold">PH.D. PROGRAM HIGHLIGHTS</h3>
                        <p class="font-semibold text-gray-500 text-lg">Disciplines Offered:</p>
                        <p class="text-gray-500 my-2">ARNI University offers Ph.D. programs through its various academic
                            schools:</p>
                        <ul class="list-disc text-gray-500 px-5">
                            <li>ARNI School of Technology</li>
                            <li>ARNI School of Business Management & Commerce</li>
                            <li>ARNI School of Arts & Humanities</li>
                            <li>ARNI School of Basic Sciences & Bio-Technology</li>
                            <li>ARNI School of Pharmacy</li>
                        </ul>
                        <p class="text-gray-500 my-2">These schools provide broad research areas, encouraging candidates
                            to
                            explore their academic interests and contribute to cutting-edge developments in their
                            respective
                            domains.</p>
                    </div>
                    <div>
                        <p class="font-semibold text-gray-500 text-lg">Eligibility Criteria:</p>
                        <ul class="list-disc text-gray-500 px-5">
                            <li>To be eligible for admission into the Ph.D. program, candidates must possess a
                                Postgraduate (Master’s) degree in a relevant discipline with at least 55% marks or an
                                equivalent CGPA.
                            </li>
                            <li>A relaxation of 5% in marks is applicable for candidates belonging to reserved
                                categories, as per UGC Guidelines.
                            </li>
                        </ul>
                    </div>
                    <div class="my-2">
                        <p class="font-semibold text-gray-500 text-lg">Admission Process:</p>
                        <p class="text-gray-500 mb-2">Admission to the Ph.D. program involves a two-step process:</p>
                        <ol class="list-decimal list-inside space-y-2 text-gray-500 px-1">
                            <li><span class="font-semibold">Entrance Examination – </span>Applicants must appear for an
                                entrance test conducted by ARNI University or present a valid score in national-level
                                exams such as UGC-NET or CSIR-NET.
                            </li>
                            <li><span class="font-semibold">Personal Interview – </span>Shortlisted candidates from the
                                entrance test are invited for a personal interview to evaluate their research aptitude,
                                academic background, and alignment with proposed research interests.
                            </li>
                        </ol>
                        <p class="text-gray-500 my-2">The admission process strictly adheres to the UGC guidelines to
                            ensure transparency and academic integrity.</p>
                    </div>
                    <div>
                        <h3 class="mt-6 text-[16px] font-semibold">WHY CHOOSE ARNI UNIVERSITY?</h3>
                        <ul class="list-disc text-gray-500 px-5">
                            <li>State-of-the-art research facilities</li>
                            <li>Supportive and expert faculty mentors</li>
                            <li>Emphasis on Interdisciplinary and Industry-oriented Research</li>
                            <li>Collaboration with National and International Research Institutions</li>
                            <li>Encouragement for Publications, Patents, and Innovations</li>
                        </ul>
                        <p class="text-gray-500 my-2">Our Ph.D. program is ideal for motivated individuals seeking to
                            make meaningful academic and professional contributions through high-quality research.</p>
                        <p class="text-gray-500 my-2">Embark on your research journey with ARNI University and be a part
                            of a community that values knowledge, innovation, and societal impact.</p>
                    </div>
                </div>

                <div *ngIf="pageTitle=='Research Paper'" class="mt-5">
                    <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">
                        <iframe
                            src="assets/pdf/research-paper-publication-details.pdf"
                            width="100%"
                            height="600px"
                            style="border: none;"
                            class="hidden md:block"
                        ></iframe>
                        <a
                            href="assets/pdf/research-paper-publication-details.pdf"
                            target="_blank"
                            rel="noopener"
                            class="text-blue-600 underline block md:hidden"
                        >
                            Research Paper Publication Details
                        </a>
                    </div>
                </div>

                <div *ngIf="pageTitle=='Research Projects'" class="mt-5">
                    <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">
                        <h2 class="text-xl font-semibold text-gray-600">No Data Available!</h2>
                    </div>
                </div>

                <div *ngIf="pageTitle=='Patents & Copyright'" class="mt-5">
                    <div class="md:flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow hidden">
                        <iframe
                            src="assets/pdf/au-patents.pdf"
                            width="100%"
                            height="600px"
                            style="border: none;"
                        ></iframe>
                    </div>
                    <div>
                        <a
                            href="assets/pdf/au-patents.pdf"
                            target="_blank"
                            rel="noopener"
                            class="text-blue-600 underline"
                        >
                            ARNI University Patents and Copyright
                        </a>
                    </div>
                </div>

                <div *ngIf="pageTitle === 'Ph.D. Regulations'" class="mt-5">
                    <div *ngIf="pdfUrl; else noData" class="flex justify-center">
                        <iframe
                            [src]="pdfUrl"
                            width="100%"
                            height="600px"
                            class="rounded-lg shadow border"
                            type="application/pdf"
                        ></iframe>
                    </div>

                    <ng-template #noData>
                        <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">
                            <h2 class="text-xl font-semibold text-gray-600">No Data Available!</h2>
                        </div>
                    </ng-template>
                </div>

                <div *ngIf="pageTitle=='Collaborations/MOUs'" class="mt-5">
                    <div *ngFor="let item of mous; let i = index" class="border rounded-lg overflow-hidden w-full my-4">
                        <div class="flex items-center justify-between p-4 cursor-pointer w-full" (click)="toggleMouAccordion(i)">
                            <div class="flex-1 font-medium text-xs md:text-[16px]" [ngClass]="openedIndex === i ? 'text-pink-600' : 'text-gray-800'">
                                {{ item.title }}
                            </div>

                            <div class="text-md md:text-[16px]" [ngClass]="openedIndex === i ? 'text-pink-600' : 'text-gray-700'">
                                <i class="fa" [ngClass]="openedIndex === i ? 'fa-minus' : 'fa-plus'"></i>
                            </div>
                        </div>

                        <div *ngIf="openedIndex === i" class="p-4 bg-white text-gray-700">
                            <p class="text-xs md:text-lg">{{ item.description }}</p>
                            <a
                                *ngIf="item.downloadUrl && !item.openExternally"
                                href="#"
                                (click)="openPdfModal($event, item.downloadUrl)"
                                class="text-blue-600 underline mt-2 hidden lg:inline"
                            >
                                {{ item.downloadLabel }}
                            </a>

                            <a
                                *ngIf="item.downloadUrl && item.openExternally"
                                [href]="item.downloadUrl"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline mt-2 hidden lg:inline"
                            >
                                {{ item.downloadLabel }}
                            </a>

                            <a
                                *ngIf="item.downloadUrl"
                                [href]="item.downloadUrl"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline mt-2 inline-block lg:hidden text-xs md:text-lg"
                            >
                                {{ item.downloadLabel }}
                            </a>
                        </div>
                    </div>
                    <div *ngIf="mouPdfUrl" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 px-4">
                        <div class="relative w-full max-w-5xl mx-auto">
                            <div class="flex justify-end mb-2">
                                <button
                                    (click)="closePdfModal()"
                                    class="text-white text-2xl font-bold border border-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-white hover:text-black transition"
                                >
                                    &times;
                                </button>
                            </div>

                            <div class="relative w-full pt-[56.25%] rounded-lg shadow-lg overflow-hidden">
                                <iframe
                                    [src]="sanitizedPdfUrl"
                                    class="absolute top-0 left-0 w-full h-full"
                                    frameborder="0"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="pageTitle=='Conference/Workshop'" class="mt-5">
                   <!-- <div *ngFor="let item of accordionItems; let i = index"
                         class="border border-gray-300 rounded-md mb-2 overflow-hidden">
                        <div (click)="toggleAccordion(i)"
                             class="flex items-center cursor-pointer px-4 py-3 transition-colors duration-200 text-lg"
                             [ngClass]="{'text-blue-400': activeIndex === i, 'text-black': activeIndex !== i}">
      <span class="text-xl mr-3">
        {{ activeIndex === i ? '−' : '+' }}
      </span>
                            <h2 class="text-lg font-medium">
                                {{ item.title }}
                            </h2>
                        </div>

                        <div *ngIf="activeIndex === i" class="px-4 py-2 text-gray-700 border-t border-gray-200">
                            <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">
                                <h2 class="text-xl font-semibold text-gray-600">No Data Available!</h2>
                            </div>
                        </div>

                    </div>-->
                    <div class="py-4">
                        <div class="p-6 my-4">
                            <p class="text-gray-800 font-semibold text-lg">
                                1. One day Online-Line Research Methodology workshop Organised by Arni School of Basic Sciences and Biotechnology on 13-Aug-2024.
                            </p>
                        </div>

                        <div class="p-6 my-4">
                            <p class="text-gray-800 font-semibold text-lg">
                                2. Three days International Conference On Redefining Possibilities: Crossmulti-Disciplinary Approaches to Global Challenges on 26th–28th Dec 2024.
                            </p>
                        </div>

                        <div class="my-4 p-6">
                            <p class="text-gray-800 font-semibold text-lg">
                                3. Guest Lecture on the occasion of “World Health Day: Healthy Beginnings, Hopeful Futures” on topic: “TB Mukt Bharat”, 7th April 2025.
                            </p>
                        </div>

                        <div class="p-6 my-4">
                            <p class="text-gray-800 font-semibold text-lg">
                                4. Workshop cum Seminar on “Basic Life Support and First Aid Training”, 10th March 2025.
                            </p>
                        </div>

                    </div>
                </div>

                <div *ngIf="pageTitle=='Downloads'" class="mt-5">
                    <!--  <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-lg shadow">-->
                    <div *ngFor="let item of researchDownloads; let i = index"
                         class="border border-gray-300 rounded-md mb-2 overflow-hidden">
                        <div (click)="toggleAccordion(i)"
                             class="flex items-center cursor-pointer px-4 py-3 transition-colors duration-200 text-lg"
                             [ngClass]="{'text-blue-400': activeIndex === i, 'text-black': activeIndex !== i}">
      <span class="text-xl mr-3">
        {{ activeIndex === i ? '−' : '+' }}
      </span>
                            <h2 class="text-lg font-medium">
                                {{ item.title }}
                            </h2>
                        </div>

                        <div *ngIf="activeIndex === i" class="px-4 py-2 text-gray-700 border-t border-gray-200">
                            <a
                                [href]="'assets/pdf/' + item.pdfFileName"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline cursor-pointer">
                                {{ item.description }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="recruiters" class="mt-8" *ngIf="pageTitle === 'Research Overview'">
        <div class="bg-blue-100 text-center font-sans py-12 aarni-font">
            <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
            <div class="flex items-center justify-center gap-6 py-4">
                <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                        (click)="prevSlide()">&#10094;
                </button>
                <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                    <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                         [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                        <div *ngFor="let recruiter of recruiters"
                             class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                            <img [src]="recruiter.logo" [alt]="recruiter.name"
                                 class="max-w-[80px] sm:max-w-[100px] h-auto">
                        </div>
                    </div>
                </div>
                <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                        (click)="nextSlide()">&#10095;
                </button>
            </div>
        </div>
    </div>
</section>
